import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { TriangleAlert, ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";

export default function AgeGate() {
    const nav = useNavigate();
    const [confirmed, setConfirmed] = useState(false);

    return (
        <div className="relative min-h-screen flex flex-col px-6 pt-8 pb-8 text-white">
            <button
                onClick={() => nav("/")}
                data-testid="age-gate-back"
                className="inline-flex items-center gap-1 text-xs uppercase tracking-widest text-white/50 hover:text-white w-fit"
            >
                <ArrowLeft className="w-3.5 h-3.5" /> Back
            </button>

            <div className="flex-1 flex flex-col justify-center">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.4 }}
                    className="border-4 border-dash bg-dash/5 p-8 relative"
                >
                    <div className="absolute -top-6 left-6 bg-ink-950 px-3">
                        <TriangleAlert className="w-10 h-10 text-dash" strokeWidth={2.5} />
                    </div>
                    <div className="text-[10px] uppercase tracking-[0.25em] text-dash mt-2 mb-2">Warning</div>
                    <h1 className="font-display text-5xl leading-none text-white mb-4">
                        ARE YOU <span className="text-dash">18+</span>?
                    </h1>
                    <p className="text-sm text-white/75 leading-relaxed">
                        Smash & Dash contains adult content and is intended exclusively for users who are
                        <span className="text-dash font-bold"> 18 years of age or older</span>. By confirming below you swear under penalty of perjury that you are a legal adult in your jurisdiction.
                    </p>

                    <label className="flex items-start gap-3 mt-6 cursor-pointer" data-testid="age-gate-confirm-label">
                        <input
                            type="checkbox"
                            data-testid="age-gate-checkbox"
                            checked={confirmed}
                            onChange={(e) => setConfirmed(e.target.checked)}
                            className="w-5 h-5 mt-0.5 accent-smash shrink-0 cursor-pointer"
                        />
                        <span className="text-xs uppercase tracking-wider text-white/80">
                            I confirm I am at least 18 years old.
                        </span>
                    </label>
                </motion.div>
            </div>

            <div className="flex flex-col gap-3">
                <button
                    onClick={() => nav("/waiver")}
                    disabled={!confirmed}
                    data-testid="age-gate-continue-btn"
                    className="w-full h-14 bg-smash hover:bg-smash/90 disabled:bg-white/10 disabled:text-white/30 text-white font-display text-xl tracking-wider uppercase transition-colors"
                >
                    I am 18+
                </button>
                <button
                    onClick={() => nav("/")}
                    data-testid="age-gate-exit-btn"
                    className="w-full h-12 border border-white/15 hover:bg-white/5 text-white/70 font-display text-xs tracking-widest uppercase transition-colors"
                >
                    Take me out of here
                </button>
            </div>
        </div>
    );
}
